import { Directive, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { getCurrentUserIsTrueSystemUser } from 'src/app/authentication/state/authentication.selector';
import { Register } from 'src/app/common-components/register/models/register';
import { getCallDetailsPrivileges } from 'src/app/privileges/privileges.selector';
import { CallDetailsPrivileges } from './models/call-details-privileges';
import { CallLogsFilterOptions } from './models/call-logs-filter-option';
import { CallLogsRegisterOptions } from './models/call-logs-register-options';
import { CallLogsRegisterListItem } from './models/call-logs-register-results.model';
import { callLogsRegisterAdapterActions, callLogsRegisterInitialFilter } from './state/call-logs-register.actions';
import * as callLogsRegisterReducer from './state/call-logs-register.reducer';

@Directive()
export class CallLogsRegister
   extends Register<CallLogsRegisterListItem, CallLogsRegisterOptions, OrderingOption>
   implements OnInit
{
   columns: string[];

   filters: CallLogsFilterOptions[];

   entityName = 'Call Log';

   callDetailsPrivileges$: Observable<CallDetailsPrivileges>;

   isSystemUser$: Observable<boolean>;

   constructor(public store: Store) {
      super(store, callLogsRegisterReducer.selectors, callLogsRegisterAdapterActions);
      this.callDetailsPrivileges$ = store.pipe(select(getCallDetailsPrivileges));
      this.isSystemUser$ = store.pipe(select(getCurrentUserIsTrueSystemUser));
   }

   ngOnInit() {
      this.store.dispatch(callLogsRegisterInitialFilter({ filters: this.filters, quickFilters: [] }));
      this.store.dispatch(this.actions.pageEnter());
   }
}
